// extracted by mini-css-extract-plugin
export var accordion = "_bf-0";
export var chevron = "_bf-3";
export var closed = "_bf-2";
export var content = "_bf-4";
export var open = "_bf-1";
export var rotate = "_bf-5";